// === Phase C item 6 — canvas_preview slice ===
// Ephemeral, non-undoable. Owns the "scrub to this workflow node" preview
// frame used by the docked CanvasWorkflowPanel to hard-hide canvas elements
// that are out of range at the previewed frame.
//
// previewFrame   — integer frame index (FPS=30), or null when no preview is active.
//                  When set, EditorCanvasSli renders only boxes whose
//                  resolveBoxTiming() range includes this frame. Other boxes
//                  short-circuit to null. Sub-items inside an InteractivePlugin
//                  are NOT filtered — only top-level scene boxes.
// sourceNodeId   — optional itemId of the workflow node that triggered the
//                  preview, kept so the panel can highlight the originating
//                  node without coupling it to selectInteractiveItem.
//
// Esc, click on empty canvas, or clicking the "Previewing" pill chip clears
// previewFrame back to null. The timeline playhead is intentionally NOT touched
// by this slice — it is a separate, decoupled scrub channel.
import { SET_PREVIEW_FRAME, CLEAR_PREVIEW_FRAME } from "../common/actions";

const initialState = { previewFrame: null, sourceNodeId: null };

export default function canvas_preview(state = initialState, action) {
  switch (action.type) {
    case SET_PREVIEW_FRAME: {
      const f = action.payload && action.payload.frame;
      const frame = typeof f === "number" && isFinite(f) && f >= 0 ? Math.round(f) : null;
      const sourceNodeId =
        action.payload && action.payload.sourceNodeId != null ? action.payload.sourceNodeId : null;
      return { previewFrame: frame, sourceNodeId };
    }
    case CLEAR_PREVIEW_FRAME:
      return initialState;
    default:
      return state;
  }
}
